import { render, staticRenderFns } from "./DonutGauge.vue?vue&type=template&id=49a1e8d1&"
import script from "./DonutGauge.vue?vue&type=script&lang=js&"
export * from "./DonutGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a1e8d1')) {
      api.createRecord('49a1e8d1', component.options)
    } else {
      api.reload('49a1e8d1', component.options)
    }
    module.hot.accept("./DonutGauge.vue?vue&type=template&id=49a1e8d1&", function () {
      api.rerender('49a1e8d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Gauges/DonutGauge.vue"
export default component.exports